import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {
    map,
    share,
    catchError,
    withLatestFrom,
    switchMap,
    repeat,
} from 'rxjs/operators';
import { Action, Store } from '@ngrx/store';
import { StockIpoReservationAction } from './stock-ipo-reservation.action';
import { HttpHeaders } from '@angular/common/http';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { HttpService } from '@toro/common/shared/services/http/http.service';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';


@Injectable()
export class StockIpoReservationEffects {
    constructor(
        private actions$: Actions<StockIpoReservationAction>,
        private store: Store<AppState>,
        private httpService: HttpService,
        private settings: SettingsService,
    ) { }

    createIpoReservation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StockIpoReservationAction.createIpoReservation),
            withLatestFrom(this.store.select((authStore) => authStore.authentication)),
            switchMap(([action, auth]) => { 
                const apiUrl = this.settings.getConfigurationKeyValue('ipoBackendUrl');
                const body = action.payload;
                const isLogged = !!(auth.currentUser && auth.currentUser.token);
                return this.httpService.post<any>(`${apiUrl}/ipo.reservation`, body, this._createHeaders(auth, isLogged))
                    .pipe(
                        map((ipoReservationResponse: any) => {
                            if (ipoReservationResponse && ipoReservationResponse.id) {
                                return {
                                    type: StockIpoReservationAction.createIpoReservationSuccess,
                                    payload: ipoReservationResponse
                                };
                            } else {
                                return { type: StockIpoReservationAction.ipoReservationError, payload: {} };
                            }
                        }),
                        catchError((error) => of({ type: StockIpoReservationAction.ipoReservationError, payload: error }))
                    );
            }),
            repeat(),
            share())
    );

    getIpoReservationsByCBLC$ = createEffect(() =>
        this.actions$.pipe(
            ofType(StockIpoReservationAction.getIpoReservationsByCBLC),
            withLatestFrom(this.store.select((authStore) => authStore.authentication)),
            switchMap(([action, auth]) => {
                const apiUrl = this.settings.getConfigurationKeyValue('ipoBackendUrl');
                const isLogged = !!(auth.currentUser && auth.currentUser.token);
                return this.httpService.get<any>(`${apiUrl}/ipo.reservation/cblc/${action.payload}`, this._createHeaders(auth, isLogged))
                    .pipe(
                        map((ipoReservationResponse: any) => {
                            if (ipoReservationResponse) {
                                return {
                                    type: StockIpoReservationAction.getIpoReservationsByCBLCSuccess,
                                    payload: ipoReservationResponse
                                };
                            }
                            return { type: StockIpoReservationAction.ipoReservationError, payload: {} };
                        }),
                        catchError((error) => of({ type: StockIpoReservationAction.ipoReservationError, payload: error }))
                    );
            }),
            share())
    );

    private _createHeaders(userData: UsersState, logged: boolean = false) {
        if (!logged) {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'X-SessionID': `${userData.sessionID}`,
            });
        } else {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${userData.currentUser.token}`,
            });
        }
    }
}